<template>
  <modal
    v-if="isVisible"
    class="bonus-modal"
    :visible="isVisible"
    allow-close
    @on-close="closeModal"
  >
    <!-- eslint-disable vue/no-v-html -->
    <form
      class="bonus-modal__content"
      @submit.prevent="showRegisterModal"
      v-html="modalContent"
    />
    <!-- eslint-enable vue/no-v-html -->
  </modal>
</template>

<script setup lang="ts">
import { onMounted, ref } from 'vue';

import { usePopUpActions } from './composables';

const { processModal } = usePopUpActions();

const isVisible = ref(false);
const modalContent = ref('');

function showModal(content: string) {
  modalContent.value = content;
  isVisible.value = true;
}

function closeModal() {
  isVisible.value = false;
}

function showRegisterModal() {
  closeModal();
  location.href = '#register';
}

// HOOKS

onMounted(() => {
  processModal(showModal);
});
</script>

<style lang="scss">
.bonus-modal {
  .modal-content {
    background: $blue;
    border-radius: 8px 8px 0 0;
    color: $white;
    display: flex;
    justify-content: center;
    margin: auto auto 0;
    position: relative;

    @include breakpoint("tablet") {
      border-radius: 4px;
      width: 520px;
      height: 556px;
      margin: unset;
      position: fixed;
    }
  }

  &__content {
    padding-top: 24px;
    display: flex;
    height: 100%;
    flex-direction: column;
    align-items: center;
    text-align: center;
    gap: 4px;

    @include breakpoint("tablet") {
      gap: 8px;
    }

    .cms {
      &__img {
        width: 100px;
        height: 96px;
        margin-bottom: 8px;

        @include breakpoint("tablet") {
          width: 188px;
          height: 176px;
          margin-bottom: 12px;
        }
      }

      &__title {
        font-weight: 700;
        font-family: VAGRounded, sans-serif;
        font-size: 24px;
        line-height: 32px;

        @include breakpoint("tablet") {
          font-size: 36px;
          line-height: 48px;
        }
      }

      &__text {
        font-size: 14px;
        line-height: 20px;
        white-space: pre;
        font-weight: 400;
        font-family: Gilroy, sans-serif;

        @include breakpoint("tablet") {
          font-size: 20px;
          line-height:  32px;
          white-space: normal;
          max-width: 440px;
        }
      }

      &__button {
        background-color: $white;
        border-radius: 4px;
        color: $blue;
        font-size: 14px;
        font-weight: 600;
        margin-top: 20px;
        padding: 8px 16px;
        line-height: 24px;
        width: 100%;

        @include breakpoint("tablet") {
          margin-top: 16px;
          width: auto;
        }

      }
    }
  }
}
</style>
